import { createContext } from 'react';

import { ToastsService } from '../types';

export const ToastMessagesContext = createContext<{
  service: ToastsService;
}>({
  service: null,
});
